<template>
  <div class="messages__email">
    <button v-if="!isOpen" @click="showEmail" class="button button--sec button--icon">
      <lennoc-icon image="mail--filled"></lennoc-icon>
      <span>{{ getUiString(['claim_details', 'claim', 'open_email_document']) }}</span>
    </button>
    <div v-if="isOpen">
      <p>
        {{ From }}
        <br />
        {{ To }}
        <br />
        {{ Subject }}
      </p>
      <p v-for="attachment in Attachments" :key="attachment.Name">
        <a href="#" @click.prevent="viewAttachment(attachment.index)">{{ attachment.Name }}</a>
      </p>
      <p>
        <span v-for="(line, index) in Body" :key="`bodyLine_${index}`">
          {{ line }}
          <br />
        </span>
      </p>
    </div>
    <div v-if="emailError">{{ emailError }}</div>
    <button v-if="isOpen" @click="isOpen = false" class="button button--sec button--icon">
      <lennoc-icon image="mail--filled"></lennoc-icon>
      <span>{{ getUiString(['claim_details', 'claim', 'close_email_document']) }}</span>
    </button>
    <lennoc-spinner isFullscreen="false" v-if="busy"></lennoc-spinner>
  </div>
</template>

<script>
import { APIService } from '@/api/APIService.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ClaimEmail',
  data () {
    return {
      busy: false,
      viewerData: null,
      isOpen: false,
      emailError: '',
      From: '',
      To: '',
      Subject: '',
      Body: [],
      Attachments: []
    }
  },
  props: {
    documentId: {
      type: String,
      required: true
    },
    documentAction: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    })
  },
  methods: {
    viewAttachment (index) {
      const att = this.Attachments[index]
      this.$emit('show-file', {
        Id: this.documentId,
        ...att
      })
    },
    parseAttachments (attData) {
      const attachments = !attData
        ? []
        : Array.isArray(attData) ? attData : [attData]
      let volgnr = 0
      return attachments.map(a => {
        return { index: volgnr++, Name: a.FileName, ContentType: a.ContentType }
      })
    },
    showEmail () {
      if (!this.From) {
        this.busy = true
        const api = new APIService()
        api.getEmail({ documentId: this.documentId })
          .then((response) => {
            const msg = response.data
            this.From = msg.From || ''
            this.To = msg.To || ''
            this.Subject = msg.Subject || ''
            this.Body = (msg.Body || '').trimEnd().split('\n').map((l) => l || ' ')
            this.Attachments = this.parseAttachments(msg.Attachments.EMailMessageAttachment)
          },
          (err) => {
            this.emailError = err
          }).finally(() => {
            this.isOpen = true
            this.busy = false
          })
      } else {
        this.isOpen = true
      }
    }
  }
}
</script>
